import { ListaAvisos } from '../features/avisos';
import '../styles/App.css';

function AvisosPage() {
  const handleAvisoSelect = (aviso) => {
    // Por enquanto apenas loga, mas pode expandir para mostrar detalhes
    console.log('Aviso selecionado:', aviso);
    // Futuramente pode abrir um modal ou navegar para página de detalhes
  };

  return (
    <div className="App avisos-page">
      <ListaAvisos onAvisoSelect={handleAvisoSelect} />
    </div>
  );
}

export default AvisosPage;
